import { render, staticRenderFns } from "./duoTrainingMobile.vue?vue&type=template&id=96d6a8d8&scoped=true&"
import script from "./duoTrainingMobile.vue?vue&type=script&lang=js&"
export * from "./duoTrainingMobile.vue?vue&type=script&lang=js&"
import style0 from "./duoTrainingMobile.vue?vue&type=style&index=0&id=96d6a8d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d6a8d8",
  null
  
)

export default component.exports